import { Injectable } from '@angular/core';
import { UserDataService } from '../user-data/user-data.service';

@Injectable({
  providedIn: 'root'
})
export class PermissionCheckerService {

  constructor(private userData: UserDataService) 
  {
  }

  async getUserPermissions() 
  {
    return await this.userData.getUserPermissions();
  }

  async isReadOnly() 
  {
    return (await this.getUserPermissions()).readOnly;
  }

  async isSetupReadOnly() 
  {
    return (await this.getUserPermissions()).setupReadOnly;
  }

  async hasPermission(permissionString: string) 
  {
    return (await this.getUserPermissions()).permissionTypes.includes(permissionString);
  }

  async canCRUDCustomers() 
  {
    return !(await this.isReadOnly()) && await this.hasPermission('ServiceCall_Customers');
  }

  async canCRUDCustomerLocations() 
  {
    return !(await this.isReadOnly()) && await this.hasPermission('ServiceCall_Location');
  }

  async canCRUDEquipments() 
  {
    return !(await this.isReadOnly()) && await this.hasPermission('ServiceCall_Equipment');
  }

  async canCRUDRecommendations() 
  {
    return !(await this.isReadOnly());
  }

  async canCRUDQuotes() 
  {
    return !(await this.isReadOnly()) && await this.hasPermission('ServiceCall_Quote');
  }

  async canCRUDServiceCalls() 
  {
    return !(await this.isReadOnly()) && await this.hasPermission('ServiceCall_ServiceCalls');
  }

  async canSeeCosts() 
  {
    return await this.hasPermission('ServiceCall_ShowCosts');
  }

  async canSeePrices() 
  {
    return await this.hasPermission('ServiceCall_ShowPrices');
  }

  async canUseSurveyCustomer() 
  {
    return await this.hasPermission('ServiceCall_SurveyProspectCustomer');
  }

  async canEmailCustomerQuote() 
  {
    return await this.hasPermission('ServiceCall_EmailCustomerQuote');
  }

  async canEmailCustomerQuoteAsPdfOnly() 
  {
    return await this.hasPermission('ServiceCall_EmailCustomerQuoteAsPdfOnly');
  }

  async canSeeUserDashboardSettings()
  {
    return await this.hasPermission('ServiceCall_UserDashboardSetup');
  }

  async canSeeDefaultDashboardSettings()
  {
    return await this.hasPermission('ServiceCall_DefaultDashboardSetup');
  }

  async canCRUDSurveyProspectCustomers() {
    return !(await this.isReadOnly()) && await this.hasPermission('ServiceCall_SurveyProspectCustomer'); 
  }
  async hasServiceCallQuotePermission()
  {
    return await this.hasPermission('ServiceCall_Quote');
  }

  async canShowUserQuotes() {

    return await this.hasPermission('ServiceCall_UsersOnly'); //Show Only Users Quotes
  }

  async canShowUserRegionQuotesRecs() {

    return await this.hasPermission('ServiceCall_ShowOnlyUsersRegionsQuotesRecs'); //	Show Only Users Regions Quotes / Recs
  }
}
